import React from 'react';
import usePartners from './usePartners';

export default function useInactivePartners(account, schoolStart, schoolEnd, currentTimestamp) {
  return usePartners(account, schoolStart, schoolEnd, {
    inactive: true
  });
}
